import styles from "./Pagamentos.module.css";
import load from "../../../../../Images/loading.gif";
import { useEffect, useState } from "react";
import axios from "axios";

function Pagamentos({ app }) {
    const [pagamentos, setPagamentos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPayments();
    });

    const fetchPayments = () => {
        axios.get(`https://eclipsebots.com/api/payments/${app}`, { withCredentials: true })
            .then((res) => setPagamentos(res.data))
            .catch(() => setPagamentos([]))
            .finally(() => setLoading(false));
    };

    if (loading) {
        return (
            <div className={styles.content}>
                <div className={`${styles.size} ${styles.loading}`}>
                    <img src={load} width="20px" height="20px" alt="loading" />
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>

            {pagamentos.length === 0 ? (
                <div>Nenhum pagamento a reportar.</div>
            ) : (
                <div className={styles.pagamentos}>
                    {pagamentos.map((event, index) => {
                        const isFirst = index === 0;
                        const isLast = index === pagamentos.length - 1;

                        return (
                            <div
                                key={event.invoiceId}
                                className={`
                                                ${styles.pagamento}
                                                ${isFirst ? styles.first : ""}
                                                ${isLast ? styles.last : ""}
                                            `}
                            >
                                <div className={`${styles.name} ${styles.imagem}`}>
                                    Pagamento ID {event.invoiceId}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    )
}

export default Pagamentos;